function Loader() {
  return (
    <div className="spinnerContainer">
      <div className="spinner"></div>
    </div>
  )
}

export default Loader
